import { useRef } from "react";
import { packagesData } from "../../data/dummyData";
import { Link } from "react-router-dom";
import { FaBolt, FaMapMarkerAlt } from "react-icons/fa";
import { GiSpeedBoat } from "react-icons/gi";

// Display order: speedboat, luxury-yacht, jet-ski (bayliner hidden temporarily)
const ORDER = ["speedboat", "luxury-yacht", "jet-ski"];
const sortedPackages = [...packagesData]
  .filter((p) => p.id !== "bayliner")
  .sort((a, b) => ORDER.indexOf(a.id) - ORDER.indexOf(b.id));

const Explore = () => {
  const exploreContainer = useRef(null);
  return (
    <div className="pt-12 md:pt-16 pb-16 md:pb-20 bg-gradient-to-br from-blue-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="flex flex-col md:items-center mb-8 md:mb-12 gap-4 md:gap-6">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent mb-2 md:mb-3 flex items-center gap-2 md:gap-3 justify-center">
              <GiSpeedBoat className="text-blue-600 text-2xl sm:text-3xl" />
              <span>Featured Boats</span>
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base md:text-lg max-w-3xl mx-auto leading-relaxed px-2 md:px-0">
              Choose your favorite boat and select from our curated tour
              packages. Experience the thrill of the Adriatic Sea with premium
              vessels and unforgettable water adventures tailored to your
              preferences.
            </p>
          </div>
        </div>

        {/* Tours Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6 py-2"
          ref={exploreContainer}
        >
          {sortedPackages.map((packet) => (
            <Link
              to={`/${packet.slug}/tour-details`}
              key={packet.id}
              className="group bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 dark:border-gray-700 hover:border-cyan-400 dark:hover:border-cyan-500 hover:-translate-y-1 flex flex-col h-full"
            >
              {/* Image Container */}
              <div className="relative overflow-hidden h-56">
                <img
                  src={
                    packet.gallery && packet.gallery.length > 0
                      ? packet.gallery[0]
                      : packet.images && packet.images.length > 0
                        ? packet.images[0]
                        : "/default-image.jpg"
                  }
                  alt={packet.name || packet.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                {packet.slug === "quicksilver-tour" && (
                  <div className="absolute top-3 right-3 bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-3 py-1.5 rounded-lg text-xs font-bold shadow-lg flex items-center gap-1.5">
                    <FaBolt /> Popular
                  </div>
                )}
              </div>

              {/* Content Container */}
              <div className="p-5 flex flex-col flex-1">
                {/* Location and Type Tags */}
                <div className="mb-3 flex items-center gap-2 flex-wrap">
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-cyan-700 dark:text-cyan-400 bg-cyan-50 dark:bg-cyan-900/30 px-3 py-1.5 rounded-lg">
                    <FaMapMarkerAlt /> {packet.location}
                  </span>
                  {packet.type && (
                    <span className="text-xs font-medium text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-700 px-2.5 py-1 rounded-lg capitalize">
                      {packet.type}
                    </span>
                  )}
                </div>

                {/* Title */}
                <h2 className="text-lg font-bold mb-3 text-gray-900 dark:text-white group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors duration-300 line-clamp-2 leading-tight">
                  {packet.title}
                </h2>

                {/* Price and Type */}
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100 dark:border-gray-700">
                  <div className="flex flex-col">
                    <span className="text-xs text-gray-500 dark:text-gray-400 block mb-0.5 font-medium">
                      Starting from
                    </span>
                    <span className="text-2xl font-extrabold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
                      €{packet.price}
                    </span>
                    {packet.priceLabel && (
                      <span className="text-xs text-gray-400">
                        {packet.priceLabel}
                      </span>
                    )}
                  </div>
                  <button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold px-5 py-2.5 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg group-hover:scale-105 text-sm">
                    Book Now
                  </button>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Explore;
